export const formatPrice = (price) => {
  const priceAsNumber =  (typeof(price) === 'string') ? parseFloat(price) : price;

  // Ensure the price is a number and fixed to 2 decimal places
  const parts = Number(priceAsNumber).toFixed(2).split(".");
  
  // Add thousands separator
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  // Join parts with comma as decimal separator
  return '€' + parts.join(",");

}

export const formatPhoneNumber = (phoneNumber) => {
  return phoneNumber.startsWith('+') ? phoneNumber : `+${phoneNumber}`;
}